<template>
    <div class="registration-steps-panel" :class="{ 'registration-steps-panel--three-steps': steps.length > 2 }">
        <div v-for="(step, i) in steps" :key="`${step.codeName}-${i}`" class="registration-steps-panel__item" :class="step.stepState">
            <div class="registration-steps-panel__counter">{{ i + 1 }}</div>
            <div class="registration-steps-panel__tick"><div class="registration-steps-panel__tick-icon"></div></div>
            <div class="registration-steps-panel__title">{{ step.displayName }}</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { RegistrationStepDto } from "@/account/models/authentication-models";
import { computed } from "vue";
import useAuthenticationFlows, { authenticationStep } from "@/account/composables/use-authentication-flows";

const { containsFlowState } = useAuthenticationFlows();

const steps = computed(() => {
    const registrationStepPersonal: RegistrationStepDto = {
        codeName: "accountStepPersonal",
        displayName: "Registrační údaje",
        stepState: authenticationStep.value == "RegPersonal" ? "active" : "completed" // Personal is first step => is never displayed as future
    };
    const registrationStepVerification: RegistrationStepDto = {
        codeName: "accountStepVerification",
        displayName: containsFlowState("RegNewPass") ? "Ověření uživatele" : "Ověření telefonu",
        stepState:
            authenticationStep.value == "RegPinLog" || authenticationStep.value == "RegVerPhone"
                ? "active"
                : authenticationStep.value == "RegPersonal"
                ? "future"
                : "completed"
    };
    const steps = [registrationStepPersonal, registrationStepVerification];

    if (containsFlowState("RegNewPass")) {
        steps.push({
            codeName: "accountStepPass",
            displayName: "Nastavení hesla",
            stepState: "future" // Steps are not visible in password state => password step is always displayed as future
        });
    }

    return steps;
});
</script>
